import { Avatar } from '@components/Avatar/Avatar'
import { Box, Paragraph, Stack } from '@ui'
import { type Address, useBotData, useBotStatus } from 'use-towns-client'

export const InstalledBotRow = (props: {
    appAddress: Address
    openBotProfile?: (userId: string) => void
    disableClick?: boolean
}) => {
    const { appAddress, openBotProfile, disableClick } = props
    const { data: bot } = useBotData(appAddress)
    const { data: botStatus } = useBotStatus(bot?.clientAddress)

    // Since the user will be in the space/channel panel, the bot data will be already loaded.
    // We can add a skeleton with suspense if needed.
    if (!bot) {
        return null
    }

    return (
        <Box
            horizontal
            gap="sm"
            cursor={disableClick ? undefined : 'pointer'}
            onClick={disableClick ? undefined : () => openBotProfile?.(bot.clientAddress)}
        >
            <Box centerContent opacity={botStatus?.isActive === false ? '0.5' : undefined}>
                {bot.clientAddress && <Avatar size="avatar_x4" userId={bot.clientAddress} />}
            </Box>
            <Box overflow="hidden" paddingY="xs" gap="sm">
                <Stack horizontal gap="xs" alignItems="center">
                    <Paragraph truncate data-testid="owner">
                        {bot.metadata?.displayName}
                    </Paragraph>
                    {botStatus?.isActive === false && (
                        <Paragraph color="gray2" size="xs">
                            (Deactivated)
                        </Paragraph>
                    )}
                </Stack>
                <Paragraph color="gray2">@{bot.metadata?.username}</Paragraph>
            </Box>
        </Box>
    )
}
